module.exports = __webpack_public_path__ + "static/amazon-4x-399521993ce4a2d6e76ff67ebdd2dc6a.png";